$shm_hitalama_map_widget_float_notebook2_adds_line $mol_view
	plugins /
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
	Map_page $shm_hitalama_map_page
	add_types /
		\text_md
		\code_js
		\iframe
	showed false
	left_px \0px
	top_px \0px
	real_pos /
		0
		0
	widget_add*? null
	hovered? false
	sub <= body /
	attr *
		^
		shm_hitalama_map_widget_float_notebook2_add_line_showed <= showed false
	style *
		^
		left <= left_px
		top <= top_px
	Button $mol_button_minor
		hint \Добавить
		click? <=> button_click? null
		sub /
			<= Icon $mol_icon_plus
	Pop_over $mol_pop_over
		align \right_bottom
		Anchor <= Anchor $mol_button_minor
			hint \Добавить
			sub /
				<= Icon
		bubble_content /
			<= Menu $shm_hitalama_map_page_contextmenu
				item_ids_top /
				item_ids_top2 /
				item_ids <= add_types
				Map_page <= Map_page
				contextmenu_real_pos <= real_pos
